import axios from 'axios'
import environment from '../environments/environment.dev';

const API = axios.create({ baseURL: environment.api_url });

export const createChat = (data) => API.post('/chat/', data);

export const userChats = (id) => API.get(`/chat/${id}`);

export const findChat = (firstId, secondId) => API.get(`/find-chat/${firstId}/${secondId}`);